var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 31.5,
    r: 30.5,
    fill: "#F6F6FF",
    stroke: "#EEEEFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 30.5,
    fill: "#F6F6FF",
    stroke: "#EEEEFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0957 41.1988H24.7507C23.2318 41.1988 22.0006 39.9675 22.0006 38.4487L22.0007 27.9935C22.0007 26.9463 22.0003 25.4547 22 24.3747C21.9998 23.6151 22.6155 23 23.3751 23H29.9273L33.0957 26.3844H42.625C43.3844 26.3844 44 27.0001 44 27.7595V31.412M41.9375 39.6622L43.3125 41.0372M42.625 36.9121C42.625 38.8106 41.0859 40.3497 39.1874 40.3497C37.2889 40.3497 35.7498 38.8106 35.7498 36.9121C35.7498 35.0136 37.2889 33.4745 39.1874 33.4745C41.0859 33.4745 42.625 35.0136 42.625 36.9121Z",
    stroke: "#825DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.8fb1d283af440fc25600f57e49d758c3.svg";
export { ForwardRef as ReactComponent };